import {
  faCircleCheck,
  faCircleExclamation,
  faCircleXmark,
} from '@fortawesome/free-solid-svg-icons';
import { DialogContent, Divider } from '@mui/material';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ButtonMain } from '»components/atoms/Buttons';
import { TrlFormattedMessagePlain } from '»utils/i18n';

import {
  BoxDescrMessageStyled,
  BoxTitleMessageStyled,
  DescrEmailStyled,
  DescrMessageStyled,
  DialogActionsStyled,
  DialogStyled,
  FontAwesomeIconStyled,
  IconStyledBox,
} from './TrlFeedbackModal.styles';

const TrlFeedbackDescr = ({ rawDescr, values, isFromOnboarding }) => {
  const emailRegex = /[\w.-]+@[\w.-]+\.\w+/g;

  const descr = rawDescr.includes('TRLT_UI-')
    ? TrlFormattedMessagePlain({ id: rawDescr, values })
    : rawDescr;

  const match = descr.match(emailRegex);

  if (!match || !isFromOnboarding)
    return <BoxDescrMessageStyled>{descr}</BoxDescrMessageStyled>;

  const email = match[0];
  const [beforeEmail, afterEmail] = descr.split(email);

  return (
    <BoxDescrMessageStyled>
      <DescrMessageStyled>
        {beforeEmail}
        <DescrEmailStyled component="span">{email}</DescrEmailStyled>
        {afterEmail}
      </DescrMessageStyled>
    </BoxDescrMessageStyled>
  );
};

TrlFeedbackDescr.propTypes = {
  rawDescr: PropTypes.string.isRequired,
  values: PropTypes.object,
  isFromOnboarding: PropTypes.bool,
};

export const TrlFeedbackModal = ({
  title,
  descr,
  type,
  open,
  onClose,
  mainActionBtnNameExp,
  mainActionMethod,
  isFromOnboarding,
}) => (
  <DialogStyled onClose={onClose} open={open}>
    <DialogContent id="feedbackModalContentContainer">
      <IconStyledBox>
        <FontAwesomeIconStyled
          icon={
            type === 'success'
              ? faCircleCheck
              : type === 'error'
                ? faCircleXmark
                : faCircleExclamation
          }
        />
      </IconStyledBox>
      <BoxTitleMessageStyled>
        <FormattedMessage id={title.content} values={title.values} />
      </BoxTitleMessageStyled>
      <TrlFeedbackDescr
        rawDescr={descr.content}
        values={descr.values}
        isFromOnboarding={isFromOnboarding}
      />
      <Divider />
    </DialogContent>

    <DialogActionsStyled>
      <ButtonMain
        onClick={onClose}
        variant={mainActionBtnNameExp ? 'secondary' : 'primary'}
        expressionId={
          mainActionBtnNameExp ? 'TRLT_UI-CANCEL' : 'TRLT_UI-OK_FEEDBACK'
        }
      />
      {mainActionBtnNameExp && (
        <ButtonMain
          onClick={mainActionMethod}
          expressionId={mainActionBtnNameExp}
          autoFocus
          isOneLineName
        />
      )}
    </DialogActionsStyled>
  </DialogStyled>
);

TrlFeedbackModal.propTypes = {
  title: PropTypes.object.isRequired,
  descr: PropTypes.object.isRequired,
  type: PropTypes.oneOf(['success', 'warning', 'error']),
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  mainActionBtnNameExp: PropTypes.string,
  mainActionMethod: PropTypes.func,
  isFromOnboarding: PropTypes.bool,
};
